export default function Map() {
  return (
    <iframe
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3019.7185330229536!2d14.352942976898213!3d40.81217857137872!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x133ba6f2d43640a7%3A0x88646d506eb85747!2sVia%20Nicol%C3%B2%20Marcello%20Venuti%2C%2069%2C%2080056%20Ercolano%20NA!5e0!3m2!1sit!2sit!4v1763051774536!5m2!1sit!2sit"
      width="100%"
      height="450"
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"></iframe>
  );
}
